module.exports = __webpack_public_path__ + "static/media/chat.9a861d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat.png
// module id = 402
// module chunks = 0